// src/components/Navbar.jsx
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import { useUserProfile } from "./hooks/useUserProfile";

export default function Navbar() {
    const { role, loading } = useUserProfile();
    const navigate = useNavigate();

    const handleLogout = () =>
        signOut(auth)
            .then(() => navigate("/login"))
            .catch((err) => console.error("Error al cerrar sesión", err));

    /* mientras carga perfil */
    if (loading) return null;

    /* qué links mostrar */
    const links = [
        { to: "/dashboard", label: "Conversaciones" },
        ...(role === "admin"
            ? [
                { to: "/abandoned-carts", label: "Carros abandonados" },
                { to: "/users", label: "Usuarios" },
            ]
            : []),
    ];

    return (
        <div className="navbar bg-base-200 shadow-lg py-2">
            <div className="flex-1">
                <Link to="/dashboard" className="btn btn-ghost normal-case">
                    <img src="/logo-demasled.png" alt="Logo" className="h-10" />
                </Link>
            </div>

            <div className="flex-none">
                <ul className="menu menu-horizontal p-0">
                    {links.map(({ to, label }) => (
                        <li key={to}>
                            <Link to={to}>{label}</Link>
                        </li>
                    ))}
                    <li>
                        <button onClick={handleLogout}>Cerrar Sesión</button>
                    </li>
                </ul>
            </div>
        </div>
    );
}
